import React from 'react';
import './FloatingWhatsApp.scss'; // Importing styles for WhatsApp button

function FloatingWhatsApp() {
  const whatsappNumber = "+919302306770"; // Replace with your WhatsApp number

  return (
    <a
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png"
        alt="WhatsApp"
        className="whatsapp-icon"
      />
    </a>
  );
}

export default FloatingWhatsApp;
